export default __webpack_public_path__ + "static/media/ic_times_danger.a82bab85.svg";